"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = void 0;
var Placeholder = function (target) {
    return /** @class */ (function (_super) {
        __extends(Placeholder, _super);
        function Placeholder() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            _this.placeholder = _this.normalizePlaceholder(_this.options.get('placeholder'));
            return _this;
        }
        Placeholder.prototype.normalizePlaceholder = function (placeholder) {
            if (typeof placeholder === 'string') {
                placeholder = {
                    id: '',
                    text: placeholder
                };
            }
            return placeholder;
        };
        Placeholder.prototype.createPlaceholder = function (placeholder) {
            var placeholderContainer = this.selectionContainer();
            placeholderContainer.innerHTML = this.display(placeholder);
            placeholderContainer.classList.add('select2-selection__placeholder');
            placeholderContainer.classList.remove('select2-selection__choice');
            return placeholderContainer;
        };
        Placeholder.prototype.update = function (data) {
            var singlePlaceholder = (data.length === 1 && data[0].id !== this.placeholder.id);
            var multipleSelections = data.length > 1;
            if (multipleSelections || singlePlaceholder) {
                return _super.prototype.update.call(this, data);
            }
            this.clear();
            var placeholderContainer = this.createPlaceholder(this.placeholder);
            if (placeholderContainer) {
                this.selection
                    .querySelector('.select2-selection__rendered')
                    .append(placeholderContainer);
            }
        };
        return Placeholder;
    }(target));
};
exports.Placeholder = Placeholder;
//# sourceMappingURL=placeholder.js.map